import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/auth-funnel")({
  component: lazyRouteComponent(() => import("./-pages/admin.auth-funnel")),
  head: () => ({
    meta: [
      { title: "قمع تسجيل الدخول · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
